import React, { FC } from 'react';
import { FaBars } from 'react-icons/fa6';
import { IconProps } from './common/iconProps';

export const BarsIcon: FC<IconProps> = ({ className }) => <FaBars className={className} />;
